"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateString = void 0;
var react_1 = __importDefault(require("react"));
var date_fns_1 = require("date-fns");
exports.DateString = function (_a) {
    var date = _a.date, format = _a.format;
    return react_1.default.createElement(react_1.default.Fragment, null, date_fns_1.format(date, format));
};
//# sourceMappingURL=DateString.js.map